var map = {
	"./A.mp3": "4df0",
	"./B.mp3": "d56f",
	"./C.mp3": "ea0f",
	"./D.mp3": "6df0",
	"./E.mp3": "128e",
	"./F.mp3": "4047",
	"./G.mp3": "1c19",
	"./H.mp3": "61ec",
	"./I.mp3": "3183",
	"./J.mp3": "4427",
	"./K.mp3": "7148",
	"./L.mp3": "1afc",
	"./M.mp3": "976d",
	"./N.mp3": "4764",
	"./O.mp3": "84be",
	"./P.mp3": "b5f9",
	"./R.mp3": "104d",
	"./S.mp3": "dbe8",
	"./T.mp3": "1549",
	"./U.mp3": "b5f92",
	"./W.mp3": "799c",
	"./Y.mp3": "69cc",
	"./Z.mp3": "c5c1",
	"./Ó.mp3": "885a",
	"./Ą.mp3": "7229",
	"./Ć.mp3": "53e3",
	"./Ę.mp3": "59b4",
	"./Ł.mp3": "eb0a",
	"./Ś.mp3": "29fc",
	"./Ź.mp3": "9095",
	"./Ż.mp3": "26fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ad8";